export function prepareDeliveryItems(userRoleName) {
    const wrapWithParentForAdmin = (items) => {
        const extendedItems = items.map((item) => ({
            ...item, roles: ['admin', ...item.roles]
        }));

        return {
            name: 'delivery',
            loggedIn: true,
            icon: 'mdi-silverware',
            children: extendedItems
        };
    };

    const items = [{
        name: 'establishmentsTypes',
        to: { path: '/establishments-types' },
        icon: 'mdi-format-list-checks',
        roles: ['admin-delivery'],
        loggedIn: true
    }, {
        name: 'establishmentsCategories',
        to: { path: '/establishments-categories' },
        icon: 'mdi-silverware-fork-knife',
        roles: ['admin-delivery'],
        loggedIn: true
    }, {
        name: 'establishments',
        to: { path: '/establishments' },
        icon: 'mdi-format-list-bulleted-triangle',
        roles: ['admin-delivery'],
        loggedIn: true
    }, {
        name: 'sections',
        to: { path: '/sections' },
        icon: 'mdi-arrange-bring-to-front',
        roles: ['admin-delivery', 'admin-establishment'],
        loggedIn: true
    }, {
        name: 'products',
        to: { path: '/products' },
        icon: 'mdi-food',
        roles: ['admin-delivery', 'admin-establishment', 'manager-establishment-ext'],
        loggedIn: true
    }, {
        name: 'importProducts',
        to: { path: '/import-products' },
        icon: 'mdi-file-import',
        roles: ['admin-delivery', 'admin-establishment'],
        loggedIn: true
    }];

    if (['admin', 'admin-delivery'].includes(userRoleName)) {
        items.push({
            name: 'deliveryReports',
            to: {path: '/delivery-reports'},
            icon: 'move_to_inbox',
            roles: ['admin-delivery', 'admin'],
            loggedIn: true
        });
    }

    if (['admin'].includes(userRoleName)) {
        return [wrapWithParentForAdmin(items, 'admin')];
    }

    return items;
}

export default {
    prepareDeliveryItems
};
